export default __webpack_public_path__ + "static/media/49.71c0ca50.jpeg";